import { useI18n } from '../i18n';

// 颜色图例:命中 / 无命中 / (数值)答案高低 / 距离连续渐变
export default function Legend({ numbers = false }: { numbers?: boolean }) {
  const { t } = useI18n();
  return (
    <div className="legend">
      <span>
        <i className="sw hit" />
        {t.legend.correct}
      </span>
      <span>
        <i className="sw miss" />
        {t.legend.incorrect}
      </span>
      {numbers && <span className="lg-num">{t.legend.numbers}</span>}
      <span className="lg-grad">
        <i className="grad-bar" />
        {t.legend.distance}
      </span>
    </div>
  );
}
